module.exports = __webpack_public_path__ + "f0a56436467256fb7a0f03716c775846.jpg";